import Image from "next/image";

export function SpaceError({ className }: { className?: string }) {
  return (
    <Image
      src="/images/error-astronaut.jpg"
      alt=""
      width={1920}
      height={1920}
      sizes="(max-width: 640px) 100vw, 288px"
      className={className}
      priority
    />
  );
}